/* Altera Wishlist client
   Growave replacement — talks to Mel Worker (/api/wishlist/*).

   Two states:
     - Customer logged in → uses /api/wishlist/toggle with customer_id
     - Anonymous → uses /api/wishlist/anon/toggle with a client-set cookie

   State injected by layout/theme.liquid via window.AlteraWishlistBoot:
     { workerUrl, customerId, initialItems }
   `initialItems` is the customer's metafield JSON (empty array if none).
   Anonymous shoppers get an initial fetch from the server keyed by cookie.
*/
(function () {
  'use strict';

  var boot = window.AlteraWishlistBoot || {};
  var WORKER_URL = boot.workerUrl || 'https://mel-worker.melbel1313.workers.dev';
  var CUSTOMER_ID = boot.customerId || null;
  var COOKIE_NAME = 'altera_wl';
  var LOCAL_KEY = 'altera_wishlist_v1';
  var COOKIE_DAYS = 365;

  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function writeCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 86400000);
    document.cookie = name + '=' + encodeURIComponent(value) +
      '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
  }
  function makeCookieId() {
    if (window.crypto && window.crypto.randomUUID) {
      return window.crypto.randomUUID().replace(/-/g, '');
    }
    var s = '';
    for (var i = 0; i < 32; i++) s += Math.floor(Math.random() * 16).toString(16);
    return s;
  }
  function ensureCookieId() {
    var id = readCookie(COOKIE_NAME);
    if (!id || id.length < 16) {
      id = makeCookieId();
      writeCookie(COOKIE_NAME, id, COOKIE_DAYS);
    }
    return id;
  }

  function readLocal() {
    try {
      var parsed = JSON.parse(localStorage.getItem(LOCAL_KEY) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) { return []; }
  }
  function writeLocal(items) {
    try { localStorage.setItem(LOCAL_KEY, JSON.stringify(items)); } catch (e) {}
  }

  function toGid(v) {
    var s = String(v || '').trim();
    if (s.indexOf('gid://') === 0) return s;
    var n = s.replace(/\D/g, '');
    return n ? 'gid://shopify/ProductVariant/' + n : null;
  }

  var state = { items: [], cookieId: null };

  if (CUSTOMER_ID) {
    state.items = Array.isArray(boot.initialItems) ? boot.initialItems.slice() : [];
    writeLocal(state.items);
  } else {
    state.cookieId = ensureCookieId();
    state.items = readLocal();
  }

  function isIn(gid) {
    for (var i = 0; i < state.items.length; i++) {
      if (state.items[i] && state.items[i].variant_id === gid) return true;
    }
    return false;
  }

  function paintHeart(btn) {
    var gid = toGid(btn.getAttribute('data-variant-id'));
    if (!gid) return;
    var active = isIn(gid);
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? 'Remove from Favorites' : 'Add to Favorites');
  }
  function repaintAll() {
    var nodes = document.querySelectorAll('.altera-wl-heart');
    for (var i = 0; i < nodes.length; i++) paintHeart(nodes[i]);
    document.dispatchEvent(new CustomEvent('altera:wishlist:updated', {
      detail: { count: state.items.length, items: state.items.slice() },
    }));
  }

  function toast(msg) {
    var el = document.createElement('div');
    el.className = 'altera-wl-toast';
    el.textContent = msg;
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () {
        if (el.parentNode) el.parentNode.removeChild(el);
      }, 300);
    }, 2600);
  }

  async function toggle(btn, opts) {
    var gid = toGid(btn.getAttribute('data-variant-id'));
    if (!gid) return;
    if (btn.getAttribute('data-busy') === '1') return;
    btn.setAttribute('data-busy', '1');

    var wasIn = isIn(gid);
    if (wasIn) {
      state.items = state.items.filter(function (it) { return it.variant_id !== gid; });
    } else {
      state.items.unshift({ variant_id: gid, added_at: new Date().toISOString() });
    }
    writeLocal(state.items);
    repaintAll();

    var url, body;
    if (CUSTOMER_ID) {
      url = WORKER_URL + '/api/wishlist/toggle';
      body = { customer_id: CUSTOMER_ID, variant_id: gid };
    } else {
      url = WORKER_URL + '/api/wishlist/anon/toggle';
      body = { cookie_id: state.cookieId, variant_id: gid };
    }

    try {
      var r = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      var d = await r.json();
      if (!d || !d.ok) throw new Error((d && d.error) || 'toggle failed');
      if (!wasIn && !(opts && opts.silent)) showAddedPanel(gid);
    } catch (err) {
      if (wasIn) {
        state.items.unshift({ variant_id: gid, added_at: new Date().toISOString() });
      } else {
        state.items = state.items.filter(function (it) { return it.variant_id !== gid; });
      }
      writeLocal(state.items);
      repaintAll();
      toast('Could not update your favorites. Please try again.');
    } finally {
      btn.setAttribute('data-busy', '');
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.altera-wl-heart') : null;
    if (!btn) return;
    e.preventDefault();
    toggle(btn);
  });

  if (!CUSTOMER_ID) {
    fetch(WORKER_URL + '/api/wishlist/anon/list?cookie_id=' + encodeURIComponent(state.cookieId))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.ok && Array.isArray(d.items)) {
          state.items = d.items;
          writeLocal(state.items);
          repaintAll();
        }
      })
      .catch(function () {});
  } else {
    var anonCookie = readCookie(COOKIE_NAME);
    if (anonCookie && anonCookie.length >= 16) {
      fetch(WORKER_URL + '/api/wishlist/merge', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cookie_id: anonCookie, customer_id: CUSTOMER_ID }),
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.ok) {
            writeCookie(COOKIE_NAME, '', -1);
            if (d.merged > 0) {
              fetch(WORKER_URL + '/api/wishlist/list?customer_id=' + encodeURIComponent(CUSTOMER_ID))
                .then(function (r) { return r.json(); })
                .then(function (dd) {
                  if (dd && dd.ok && Array.isArray(dd.items)) {
                    state.items = dd.items;
                    writeLocal(state.items);
                    repaintAll();
                  }
                })
                .catch(function () {});
            }
          }
        })
        .catch(function () {});
    }
  }

  function buildHeartHTML(variantId) {
    return '<button type="button" class="altera-wl-heart altera-wl-heart--md" ' +
           'data-variant-id="' + String(variantId).replace(/[^0-9]/g, '') + '" ' +
           'aria-pressed="false" aria-label="Add to wishlist">' +
           '<svg class="altera-wl-heart-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
           '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" ' +
           'stroke="currentColor" stroke-width="2" stroke-linejoin="round" fill="currentColor" fill-opacity="0" class="altera-wl-heart-path"/>' +
           '</svg></button>';
  }

  function applyInlinePdpStyle(wrap) {
    wrap.style.cssText = [
      'position: absolute',
      'top: 16px',
      'right: 16px',
      'left: auto',
      'bottom: auto',
      'width: auto',
      'height: auto',
      'z-index: 50',
      'pointer-events: auto',
      'display: block',
      'margin: 0',
      'padding: 0',
      'transform: none',
    ].join(' !important; ') + ' !important;';
  }

  function injectPdpHeart() {
    var gallery = document.querySelector('.altera-pdp-gallery');
    if (!gallery) return;

    var existing = document.querySelectorAll('.altera-wl-pdp-heart-wrap');
    for (var i = 0; i < existing.length; i++) {
      if (existing[i].parentNode) existing[i].parentNode.removeChild(existing[i]);
    }

    var variantInput = document.querySelector('[data-altera-variant-id]');
    var variantId = variantInput && variantInput.value ? variantInput.value : null;
    if (!variantId) return;

    gallery.style.setProperty('position', 'relative', 'important');
    var wrap = document.createElement('div');
    wrap.className = 'altera-wl-pdp-heart-wrap';
    wrap.setAttribute('data-wl-injected', 'js');
    applyInlinePdpStyle(wrap);
    wrap.innerHTML = buildHeartHTML(variantId);
    gallery.appendChild(wrap);
    paintHeart(wrap.querySelector('.altera-wl-heart'));
  }

  function findCardImageContainer(card) {
    return card.querySelector(
      '.altera-coll-tabbed-card-img,' +
      '.altera-coll-card-img,' +
      '.altera-coll-prod-img,' +
      '.altera-coll-prod .image,' +
      '.product-block__inner,' +
      '.image'
    ) || card;
  }

  function injectCardHearts() {
    var cards = document.querySelectorAll('[data-altera-wl-variant-id]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.closest('.altera-pdp-gallery, .altera-wishlist-page')) continue;
      if (card.querySelector('.altera-wl-card-heart-injected')) continue;

      var variantId = card.getAttribute('data-altera-wl-variant-id');
      if (!variantId) continue;

      var container = findCardImageContainer(card);
      container.style.setProperty('position', 'relative', 'important');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'altera-wl-heart altera-wl-heart--sm altera-wl-card-heart-injected';
      btn.setAttribute('data-variant-id', String(variantId).replace(/\D/g, ''));
      btn.setAttribute('data-wl-injected', 'card');
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-label', 'Add to Favorites');
      btn.style.cssText = [
        'position: absolute',
        'top: 10px',
        'right: 10px',
        'left: auto',
        'bottom: auto',
        'z-index: 4',
        'margin: 0',
        'float: none',
      ].join(' !important; ') + ' !important;';
      btn.innerHTML =
        '<svg class="altera-wl-heart-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" ' +
        'stroke="currentColor" stroke-width="2" stroke-linejoin="round" fill="currentColor" fill-opacity="0" class="altera-wl-heart-path"/>' +
        '</svg>';

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
      });
      btn.addEventListener('mousedown', function (e) {
        e.stopPropagation();
      });

      container.appendChild(btn);
      paintHeart(btn);
    }
  }

  function watchVariantChanges() {
    var input = document.querySelector('[data-altera-variant-id]');
    if (!input) return;
    var last = input.value;
    setInterval(function () {
      var cur = input.value;
      if (cur && cur !== last) {
        last = cur;
        var heart = document.querySelector('.altera-wl-pdp-heart-wrap .altera-wl-heart');
        if (heart) {
          heart.setAttribute('data-variant-id', String(cur).replace(/[^0-9]/g, ''));
          paintHeart(heart);
        }
      }
    }, 400);
  }

  function formatMoney(amount, currency) {
    var n = parseFloat(amount);
    if (isNaN(n)) return '';
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: n % 1 === 0 ? 0 : 2,
      }).format(n);
    } catch (e) {
      return '$' + n.toFixed(0);
    }
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function optionLabel(options) {
    if (!Array.isArray(options) || !options.length) return '';
    return options.map(function (o) { return o.value; }).join(' / ');
  }

  function buildCardHTML(item) {
    var img = item.image_url
      ? '<img src="' + escapeHtml(item.image_url) + '" alt="' + escapeHtml(item.image_alt || item.product_title) + '" loading="lazy">'
      : '<span class="altera-wl-card__image--placeholder">' + escapeHtml(item.product_title) + '</span>';
    var variantLabel = optionLabel(item.options) || item.variant_title || '';
    var priceStr = item.price ? formatMoney(item.price, item.currency) : '';
    var addBtn = item.available
      ? '<button type="button" class="altera-wl-card__add" data-wl-add data-variant-id="' + escapeHtml(String(item.variant_id).replace(/\D/g, '')) + '">Add to bag</button>'
      : '<button type="button" class="altera-wl-card__add" disabled>Out of stock</button>';
    return (
      '<article class="altera-wl-card" data-wl-item="' + escapeHtml(item.variant_id) + '">' +
      '<button type="button" class="altera-wl-card__remove" data-wl-remove aria-label="Remove from wishlist">×</button>' +
      '<a href="' + escapeHtml(item.product_url) + '" class="altera-wl-card__image">' + img + '</a>' +
      '<div class="altera-wl-card__body">' +
      '<a href="' + escapeHtml(item.product_url) + '" class="altera-wl-card__title">' + escapeHtml(item.product_title) + '</a>' +
      (variantLabel ? '<div class="altera-wl-card__variant">' + escapeHtml(variantLabel) + '</div>' : '') +
      (priceStr ? '<div class="altera-wl-card__price">' + escapeHtml(priceStr) + '</div>' : '') +
      (item.available ? '' : '<span class="altera-wl-card__oos">Out of stock</span>') +
      '</div>' +
      '<div class="altera-wl-card__actions">' + addBtn + '</div>' +
      '</article>'
    );
  }

  function getPageRoot() {
    return document.querySelector('.altera-wishlist-page');
  }

  function updateCounters() {
    var count = state.items.length;
    document.querySelectorAll('[data-altera-wl-count]').forEach(function (el) {
      el.textContent = String(count);
    });
    document.querySelectorAll('[data-altera-wl-count-plural]').forEach(function (el) {
      el.textContent = count === 1 ? '' : 's';
    });
    var badge = document.querySelector('[data-altera-wl-header-badge]');
    if (badge) {
      badge.textContent = String(count);
      badge.setAttribute('data-count', String(count));
      badge.hidden = count === 0;
    }
  }

  async function fetchDetails(variantIds) {
    if (!variantIds.length) return [];
    try {
      var r = await fetch(WORKER_URL + '/api/wishlist/details', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ variant_ids: variantIds }),
      });
      var d = await r.json();
      return d && d.ok && Array.isArray(d.items) ? d.items : [];
    } catch (e) { return []; }
  }

  async function renderWishlistPage() {
    var root = getPageRoot();
    if (!root) return;
    var loading = root.querySelector('[data-altera-wl-loading]');
    var empty = root.querySelector('[data-altera-wl-empty]');
    var grid = root.querySelector('[data-altera-wl-grid]');
    var actions = root.querySelector('[data-altera-wl-actions]');

    updateCounters();

    var variantIds = state.items.map(function (it) { return it.variant_id; });
    if (!variantIds.length) {
      if (loading) loading.hidden = true;
      if (empty) empty.hidden = false;
      if (grid) { grid.hidden = true; grid.innerHTML = ''; }
      if (actions) actions.hidden = true;
      return;
    }

    var details = await fetchDetails(variantIds);
    var lookup = {};
    details.forEach(function (d) { lookup[d.variant_id] = d; });
    var orderedItems = variantIds.map(function (id) { return lookup[id]; }).filter(Boolean);

    if (!orderedItems.length) {
      if (loading) loading.hidden = true;
      if (empty) empty.hidden = false;
      if (grid) { grid.hidden = true; grid.innerHTML = ''; }
      if (actions) actions.hidden = true;
      return;
    }

    if (loading) loading.hidden = true;
    if (empty) empty.hidden = true;
    if (grid) {
      grid.innerHTML = orderedItems.map(buildCardHTML).join('');
      grid.hidden = false;
    }
    if (actions) actions.hidden = false;
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var removeBtn = e.target.closest('[data-wl-remove]');
    if (removeBtn) {
      e.preventDefault();
      var card = removeBtn.closest('[data-wl-item]');
      var gid = card ? card.getAttribute('data-wl-item') : null;
      if (!gid) return;
      var fakeHeart = document.querySelector('.altera-wl-heart[data-variant-id="' + String(gid).replace(/\D/g, '') + '"]');
      if (fakeHeart) {
        toggle(fakeHeart);
      } else {
        var temp = document.createElement('button');
        temp.className = 'altera-wl-heart';
        temp.setAttribute('data-variant-id', String(gid).replace(/\D/g, ''));
        toggle(temp);
      }
      if (card && card.parentNode) card.parentNode.removeChild(card);
      setTimeout(renderWishlistPage, 400);
      return;
    }

    var addBtn = e.target.closest('[data-wl-add]');
    if (addBtn && !addBtn.disabled) {
      e.preventDefault();
      var vid = addBtn.getAttribute('data-variant-id');
      if (!vid) return;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 }),
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          addBtn.textContent = 'Added';
          setTimeout(function () {
            addBtn.textContent = 'Add to bag';
            addBtn.disabled = false;
          }, 1500);
          document.dispatchEvent(new CustomEvent('altera:cart:updated'));
        })
        .catch(function () {
          addBtn.textContent = 'Try again';
          addBtn.disabled = false;
        });
      return;
    }

    var addAll = e.target.closest('[data-altera-wl-add-all]');
    if (addAll && !addAll.disabled) {
      e.preventDefault();
      var addBtns = Array.prototype.slice.call(document.querySelectorAll('[data-wl-add]:not([disabled])'));
      if (!addBtns.length) return;
      addAll.disabled = true;
      addAll.textContent = 'Adding all...';
      var items = addBtns.map(function (b) {
        return { id: parseInt(b.getAttribute('data-variant-id'), 10), quantity: 1 };
      });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function () {
          addAll.textContent = 'Try again';
          addAll.disabled = false;
        });
      return;
    }
  });

  document.addEventListener('altera:wishlist:updated', function () {
    updateCounters();
  });

  /* Added-to-favorites side panel */
  var panelEls = null;

  function ensurePanel() {
    if (panelEls) return panelEls;
    var backdrop = document.createElement('div');
    backdrop.className = 'altera-wl-panel-backdrop';
    backdrop.setAttribute('data-altera-wl-panel-backdrop', '');
    document.body.appendChild(backdrop);

    var panel = document.createElement('aside');
    panel.className = 'altera-wl-panel';
    panel.setAttribute('data-altera-wl-panel', '');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Added to Favorites');
    panel.innerHTML =
      '<div class="altera-wl-panel__head">' +
        '<h2 class="altera-wl-panel__title">' +
          '<span class="altera-wl-panel__title-check" aria-hidden="true">✓</span>' +
          '<span>Added to Favorites</span>' +
        '</h2>' +
        '<button type="button" class="altera-wl-panel__close" aria-label="Close">×</button>' +
      '</div>' +
      '<div class="altera-wl-panel__body">' +
        '<div class="altera-wl-panel__product" data-altera-wl-panel-product></div>' +
        '<div class="altera-wl-panel__actions">' +
          '<a href="/pages/favorites" class="altera-btn-primary">View Favorites</a>' +
          '<button type="button" class="altera-btn-secondary" data-altera-wl-panel-continue>Continue Shopping</button>' +
        '</div>' +
        '<div class="altera-wl-panel__recs-wrap" data-altera-wl-panel-recs hidden>' +
          '<h3 class="altera-wl-panel__rec-h">You may also like</h3>' +
          '<div class="altera-wl-panel__rec-grid" data-altera-wl-panel-rec-grid></div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(panel);

    panel.querySelector('.altera-wl-panel__close').addEventListener('click', closePanel);
    panel.querySelector('[data-altera-wl-panel-continue]').addEventListener('click', closePanel);
    backdrop.addEventListener('click', closePanel);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePanel();
    });

    panelEls = { panel: panel, backdrop: backdrop };
    return panelEls;
  }

  function closePanel() {
    if (!panelEls) return;
    panelEls.panel.classList.remove('is-open');
    panelEls.backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function openPanel() {
    ensurePanel();
    panelEls.panel.classList.add('is-open');
    panelEls.backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  async function fetchRecommendations(productHandle) {
    if (!productHandle) return [];
    try {
      var r = await fetch('/products/' + encodeURIComponent(productHandle) + '.js');
      if (!r.ok) return [];
      var p = await r.json();
      var pid = p.id;
      var recR = await fetch('/recommendations/products.json?product_id=' + pid + '&limit=4&intent=related');
      if (!recR.ok) return [];
      var recD = await recR.json();
      return Array.isArray(recD.products) ? recD.products : [];
    } catch (e) { return []; }
  }

  function renderPanelProduct(item) {
    var els = ensurePanel();
    var slot = els.panel.querySelector('[data-altera-wl-panel-product]');
    var variantLabel = optionLabel(item.options) || item.variant_title || '';
    var priceStr = item.price ? formatMoney(item.price, item.currency) : '';
    slot.innerHTML =
      '<a href="' + escapeHtml(item.product_url) + '" class="altera-wl-panel__product-img">' +
        (item.image_url ? '<img src="' + escapeHtml(item.image_url) + '" alt="' + escapeHtml(item.image_alt || item.product_title) + '">' : '') +
      '</a>' +
      '<div class="altera-wl-panel__product-info">' +
        '<a href="' + escapeHtml(item.product_url) + '" class="altera-wl-panel__product-title">' + escapeHtml(item.product_title) + '</a>' +
        (variantLabel ? '<div class="altera-wl-panel__product-variant">' + escapeHtml(variantLabel) + '</div>' : '') +
        (priceStr ? '<div class="altera-wl-panel__product-price">' + escapeHtml(priceStr) + '</div>' : '') +
      '</div>';
  }

  function renderPanelRecs(products) {
    var els = ensurePanel();
    var wrap = els.panel.querySelector('[data-altera-wl-panel-recs]');
    var grid = els.panel.querySelector('[data-altera-wl-panel-rec-grid]');
    if (!products.length) { wrap.hidden = true; return; }
    grid.innerHTML = products.slice(0, 4).map(function (p) {
      var img = (p.featured_image || p.image || '');
      var priceCents = p.price_min || p.price || 0;
      var priceStr = formatMoney(priceCents / 100, 'USD');
      return (
        '<a href="' + escapeHtml(p.url || ('/products/' + p.handle)) + '" class="altera-wl-panel__rec">' +
        '<div class="altera-wl-panel__rec-img">' +
          (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
        '</div>' +
        '<div class="altera-wl-panel__rec-body">' +
          '<div class="altera-wl-panel__rec-title">' + escapeHtml(p.title) + '</div>' +
          '<div class="altera-wl-panel__rec-price">' + escapeHtml(priceStr) + '</div>' +
        '</div>' +
        '</a>'
      );
    }).join('');
    wrap.hidden = false;
  }

  async function showAddedPanel(variantGid) {
    openPanel();
    var details = await fetchDetails([variantGid]);
    if (!details.length) { closePanel(); return; }
    var item = details[0];
    renderPanelProduct(item);
    var recs = await fetchRecommendations(item.product_handle);
    renderPanelRecs(recs);
  }

  /* Share button on favorites page */
  document.addEventListener('click', function (e) {
    var shareBtn = e.target.closest && e.target.closest('[data-altera-wl-share]');
    if (!shareBtn) return;
    e.preventDefault();
    var page = document.querySelector('.altera-wishlist-page');
    var pageUrl = page && page.getAttribute('data-favorites-url') ? page.getAttribute('data-favorites-url') : '/pages/favorites';
    var fullUrl = window.location.origin + pageUrl;
    if (navigator.share) {
      navigator.share({ title: 'My Altera Favorites', url: fullUrl }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(fullUrl).then(function () {
        shareBtn.classList.add('is-copied');
        setTimeout(function () { shareBtn.classList.remove('is-copied'); }, 2500);
      });
    }
  });

  function init() {
    injectPdpHeart();
    injectCardHearts();
    watchVariantChanges();
    repaintAll();
    updateCounters();
    if (getPageRoot()) renderWishlistPage();

    if (typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(function () { injectCardHearts(); });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.AlteraWishlist = {
    getCount: function () { return state.items.length; },
    getItems: function () { return state.items.slice(); },
    getCookieId: function () { return state.cookieId; },
    isInWishlist: function (variantId) {
      var gid = toGid(variantId);
      return gid ? isIn(gid) : false;
    },
    refresh: repaintAll,
  };
})();
